<div class="full-height">
  <router-outlet></router-outlet>
  <div class="loading-container">
    <div class="loading-content">
      <i class="fa fa-shield-alt"></i>
    </div>
  </div>
</div>
